module.exports = __webpack_public_path__ + "static/services-icons-909b88b2123f445138088a5d5934b7f6.png";